import { render, staticRenderFns } from "./ConfirmationDialogActivityForumEditThread.vue?vue&type=template&id=7ee132bf"
import script from "./ConfirmationDialogActivityForumEditThread.vue?vue&type=script&lang=js"
export * from "./ConfirmationDialogActivityForumEditThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports